import React from "react";
import Layout from "../components/Layouts/Layout";
import Meta from "../components/Layouts/Meta";
import Ticker from "./ticker";

const NotFound: React.FC = () => {
  return (
    <Layout
      meta={
        <Meta
          title="Strategy Details"
          description="Strategy details"
        />
      }
      footer={""}
    >
      {/* <div className="border border-x-0 py-2">
        <Ticker />
      </div> */}
      <div className=" text-black mx-auto mt-5 p-5 border border-sky shadow-2xl rounded-lg">
        <div className="p-5 shadow-[0px_5px_10px_0px_rgba(0,0,0,0.2)] dark:shadow-none dark:bg-black16 rounded-lg w-full max-w-[100%]">
          <div className="h-96 text-white relative top-[50%] w-full flex justify-center items-center">
            No Results Found
          </div>
        </div>
      </div>
    </Layout>
  );
};
export default NotFound;
